import React from 'react';
import '../styles/PrivacyPolicy.scss';
import View from '../components/View';
import PageHeader from '../components/PageHeader';
import carpet from './../assets/images/tile-term.png';

const PrivacyPolicy = () => {
  return (
    <View>
      <PageHeader text="Privacy Policy" imageUrl={carpet} />
      <div className="container p-5">
        <p className="font-bold pb-3">Privacy Policy</p>
        <p className="pb-4">
          <b>General</b>
          <br />
          Likewise Group PLC is committed to maintaining your privacy and we
          have set out below how we go about doing this. This policy covers
          Likewise Group PLC&apos;s use of personal information that Likewise Group
          Plc collects when you use our website. The policy also contains
          information about cookies. The following polices are intended to
          protect your privacy and ensure that your personal information is
          handled in a safe and responsible manner. We encourage you to refer to
          this policy on an ongoing basis to stay abreast of our most current
          privacy policy practices. This policy is effective from 25th May 2018.
        </p>

        <p className="pb-4">
          <b>1. Privacy Policy</b>
          <br />
          The law of England and Wales governs access to and use of this
          website. By accessing this website, you acknowledge that you have read
          and understood the conditions of use, the privacy policy and have
          agreed to accept these conditions and you represent and warrant you
          satisfy any investor qualification tests required to be met by you in
          accessing the site or by any potential investment in any products on
          which information is provided.
        </p>

        <p className="pb-4">
          This website is run by Likewise Group Plc and we are committed to
          protecting and respecting your privacy.
        </p>

        <p className="pb-4">
          This Privacy and Cookies Policy (this Policy) (together with our
          Disclaimer Agreement which contains terms of use of our website and
          any other documents referred to on it) sets out the basis on which any
          personal data we collect from you, or that you provide to us, will be
          processed by us. Please read the following carefully to understand our
          views and practices regarding your personal data (the Data) and how we
          will treat it. By visiting our website you are accepting and
          consenting to the practices described in this Policy.
        </p>

        <p className="pb-4">
          For the purpose of the General Data Protection Regulation (the Act),
          we are the data controller and our registered address is at Unit 6
          Topaz Business Park, Birmingham Road, Bromsgrove. B61 0GD
        </p>

        <p className="pb-4">
          The nature of the restricted regulated services (the Services) as
          advertised to be provided by us on our website means that we might
          obtain certain Data about you. This statement sets out the principles
          governing our use of your Data (Use). By registering and using our
          website generally, you agree to this Use.
        </p>

        <p className="pb-4">
          <b>2. General Data Protection Regulation (GDPR)</b>
          <br />
          Likewise Group PLC is committed to comply with GDPR (General Data
          Protection Regulation) principles and regulations. We have undertaken
          important steps to ensure we obtain your consent prior to processing
          or using any personal data. We aim to provide you with clear,
          accessible and intelligible information on how we obtain and process
          your personal data. We have taken our best endeavours to ensure that
          our privacy policy and cookies policy is accessible and comprehensive
          for all users.
        </p>

        <p className="pb-4">
          I. Information we collect from you
          <br />
          We will collect and process the following Data about you:
          <br />
          a. Information you give us
          <br />
          This is information about you that you give us by filling in forms on
          our website or by corresponding with us by phone, e-mail or otherwise.
          It includes information you provide when you register to use our
          website, subscribe to our online service, search for an investment
          product and any other activities commonly carried out on our website.
          The information you give us may include your name, address, e-mail
          address and phone number and financial information indicative of your
          financial standing with respect to any proposed investment you may
          wish to make and that we have been requested to obtain on behalf of
          clients.
        </p>

        <p className="pb-4">
          b. Information we collect about you
          <br />
          With regard to each of your visits to our website we may collect the
          following information from time to time:
          <br />
          Technical information, including the Internet protocol (IP) address
          used to connect your computer to the Internet, your login information,
          browser type and version, time zone setting, browser plug-in types and
          versions, operating system and platform; information about your visit,
          including the full Uniform Resource Locators (URL), clickstream to,
          through and from our website (including date and time), products you
          viewed or searched for’ page response times, download errors, length
          of visits to certain pages, page interaction information (such as
          scrolling, clicks, and mouse-overs), methods used to browse away from
          the page and any phone number used to call our customer service
          number. We will ensure we obtain your full consent prior to obtaining
          any information from you.
        </p>

        <p className="pb-4">
          II. Uses made of the information
          <br />
          We will use this information:
          <br />
          to provide you with information about the investment products you
          enquired about; to notify you about changes to our service; to ensure
          that content from our website is presented in the most effective
          manner for you and for your computer.
        </p>

        <p className="pb-4">
          III. Disclosure of your Data
          <br />
          For the avoidance of doubt, we will not disclose your Data to any
          third parties other than in accordance with this Policy and in the
          circumstances detailed below:
          <br />
          Any member of our group, which means our subsidiaries, our ultimate
          holding company and its subsidiaries, as defined in section 1159 of
          the UK Companies Act 2006.
          <br />
          Selected third parties such as prospective investors and our business
          partners.
          <br />
          In the event that we sell any or all of our business to the buyer.
          <br />
          Where we are legally required by law to disclose your personal
          information.
          <br />
          To further fraud protection and reduce the risk of fraud.
        </p>

        <p className="pb-4">
          IV. Where we store your personal data
          <br />
          We will take all steps reasonably necessary to ensure that your data
          is treated securely and in accordance with this Policy.
          <br />
          All information you provide to us is stored on our secure servers.
          Where we have given you (or where you have chosen) a password which
          enables you to access certain parts of our website, you are
          responsible for keeping this password confidential. We ask you not to
          share a password with anyone.
        </p>

        <p className="pb-4">
          V. Your rights
          <br />
          You have the right to ask us not to process your personal data for
          marketing purposes. We will expressly request your approval before
          collecting your data. Equally, we will obtain your consent should we
          intend to use your data for such purposes or if we intend to disclose
          your information to any third party for marketing purposes. You can
          exercise your right to prevent such processing by checking certain
          boxes on the forms we use to collect your data. You have the right to
          request for your personal data to be permanently erased from our
          system. The right to erasure is also known as the ‘right to be
          forgotten’. This can be made by your verbal or written request.
          <br />
          You can exercise your rights at any time by contacting us on
          atinfo@likewisegroup.co.uk
        </p>

        <p className="pb-4">
          VI. Third Party Links
          <br />
          Our website may, from time to time, contain links to and from other
          websites. The fact that we have provided these third-party links at
          our website does not constitute an endorsement, authorisation,
          sponsorship or affiliation by us with respect to the third party’s
          website, its owners or its providers. If you follow a link to any of
          these websites, please note that these websites have their own privacy
          policies and that we do not accept any responsibility or liability for
          these policies. Please check their policies before you submit any
          personal data to these websites.
          <br />
          Marketing tools used by Likewise Group PLC may share your information
          with processors, however we abide to obtain your consent prior to
          sending any information, in line with protocols established by the
          General Data Protection Regulation (GDPR) April 2016. Some of the
          processors include The Rocket Science Group LLC (MailChimp). We
          welcome you to read their privacy policies.
        </p>

        <p className="pb-4">
          VII. Access to Data
          <br />
          In accordance with the Act you have the right to access any Data that
          we hold relating to you. Please note that we will use our best
          endeavours to reply as soon as possible to your request, however
          standard timeframes allow up to one month to comply with any requests.
        </p>

        <p className="pb-4">
          <b>3. Cookies Policy</b>
          <br />
          Cookies are tiny text files (made up of letters and numbers) stored on
          your browser or the hard drive of your computer if you agree. Cookies
          contain information that is transferred to your computer’s hard drive.
          EU legislation states that all websites should let you know when they
          are using your cookies. Please note we use cookies from analytics
          service providers such as Google Analytics and from third party ad
          networks such as Google AdWords, Twitter, Facebook and LinkedIn.
        </p>

        <p className="pb-4">
          Our website uses cookies to distinguish you from other users of our
          website. This helps us to provide you with a good experience when you
          browse our website and also allows us to improve our website. Cookies
          do not tell us who you are or give us any personal details about you.
          Third party ad networks use cookies to collect non-personal data about
          your activities on this and other Web sites to provide you targeted
          advertising based upon your interests. If you wish to not have this
          information used for the purpose of serving you targeted ads, you may
          opt-out by clicking. Please note this does not opt you out of being
          served advertising. You will continue to receive generic ads.
        </p>

        <p className="pb-4">
          We cannot guarantee full operability of our website if you disable
          your cookies. For detailed information about cookies, please visit
          http://www.allaboutcookies.org/. By continuing to browse the site, you
          are agreeing to our use of cookies.
        </p>

        <p className="pb-4">
          <b>Contacting Us</b><br />
          Please do not hesitate to contact us regarding any
          matter relating to this Policy at info@likewisegroup.co.uk
        </p>
      </div>
    </View>
  );
};

export default PrivacyPolicy;
